var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"progress-wrapper"},[_c('progress',{ref:"progress",staticClass:"progress",class:_vm.newType,attrs:{"max":_vm.max}},[_vm._v(_vm._s(_vm.newValue))]),(_vm.showValue)?_c('p',{staticClass:"progress-value"},[_vm._t("default",function(){return [_vm._v(_vm._s(_vm.newValue))]})],2):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }